import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'

export default function Forpayment() {
  return (
    
      <Box borderWidth={1} borderRadius={8} p={4} mb={4}>
        <Text fontSize="md" fontWeight="bold" mb={2}>Product Details</Text>
        <Text fontSize="md" mb={2}>Product Name: Example Product</Text>
        <Text fontSize="md" mb={2}>Price: $19.99</Text>
      </Box>
 
  )
}
